import type { ActionTypes } from '../../../../types/CIAM'

export const action = async (type: ActionTypes) => {
	const actionResponse =
		await window.myTSAccountProtection.triggerActionEvent(type)

	return actionResponse.actionToken
}
